import React, { useImperativeHandle, useRef, forwardRef, useState, useEffect } from 'react';
import { matchEmail, subscribeEmail } from '../../util';
import $ from "jquery";
import raf from 'raf';

interface Props {
};

interface RefProps {
    show: () => void;
    hide: () => void;
};

const Popup = forwardRef<RefProps, Props>((props, ref) => {
    const nodeRef: any = useRef(null);
    const inputRef: any = useRef(null);
    const buttonRef: any = useRef(null);
    const checkbox: any = useRef({ tips: false, updates: false });
    const [ dummy, setDummy ] = useState(0);
    const [ status, setStatus ] = useState('initial');

    const show = () => {
	const node = $(nodeRef?.current);
	const body = $('body');

	node.show();
	body.addClass('noScroll');
	raf(() => {
	    node.addClass('show');
	});
    };

    const hide = () => {
	const node = $(nodeRef?.current);
	const body = $('body');

	node.removeClass('show');
	body.removeClass('noScroll');

	window.setTimeout(() => {
	    reset();
	    node.hide();
	}, 500);
    };

    const reset = () => {
	setStatus('initial');
	$(inputRef.current).val('');
	checkbox.current = { tips: false, updates: false };
    };

    const isValid = (): boolean => {
	const validEmail = matchEmail(inputRef?.current?.value);

	return !!validEmail && (checkbox.current.tips || checkbox.current.updates);
    };

    const validate = () => {
	$(buttonRef?.current).toggleClass('disabled', !isValid());
    };

    const onCheckbox = (target: any) => {
	checkbox.current[target] = !checkbox.current[target];

	setDummy(dummy + 1);
	validate();
    };

    const onSubmit = () => {
	if (!isValid()) {
	    return;
	};

	const { tips, updates } = checkbox.current;
	const button = $(buttonRef?.current);
	const data: { email: string, listId: string[] } = {
	    email: inputRef?.current?.value,
	    listId: [
		tips ? '955999a7-2abb-4e72-b0e1-9a807306ceb2' : '',
		updates ? 'fda6fb49-fd37-4454-942b-a8c7be917c0b' : ''
	    ].filter(it => it),
	};

	button.addClass('loading');
	subscribeEmail(data).then(res => {
	    button.removeClass('loading');
	    $(inputRef.current).val('');

	    if (!res) {
		setStatus('error');
		return;
	    };

	    setStatus('success');
	});
    };

    let formContent: any = '';
    switch (status) {
	case 'initial': {
	    formContent = (
		<>
		    <h4>Sign up to receive</h4>

		    <div className="options">
			<div className="checkbox" onClick={() => onCheckbox('tips')}>
			    <div className={[ 'icon', checkbox?.current.tips ? 'checked' : '' ].join(' ')} />
			    <p>Insider tips & tutorials on using Anytype</p>
			</div>
			<div className="checkbox" onClick={() => onCheckbox('updates')}>
			    <div className={[ 'icon', checkbox?.current.updates ? 'checked' : '' ].join(' ')} />
			    <p>Product updates and company news</p>
			</div>
		    </div>

		    <div className="inputWrapper">
			<input ref={inputRef} onKeyUp={validate} type="text" placeholder="E-mail" />
		    </div>

		    <div ref={buttonRef} onClick={onSubmit} className="button disabled">Submit</div>
		</>
	    );
	    break;
	};

	case 'success': {
	    formContent = (
		<>
		    <h4>Success!</h4>
		    <p>We look forward to updating you as new projects arise.</p>
		</>
	    );
	    break;
	};

	case 'error': {
	    formContent = (
		<>
		    <h4>Oops, something went wrong.</h4>
		    <p>Please try again later.</p>
		</>
	    );
	    break;
	};
    };

    useImperativeHandle(ref, () => ({
	show,
	hide
    }));

    return (
	<div ref={nodeRef} className="popupWrapper">
	    <div className="dimmer" onClick={hide} />
	    <div className="popup">
		<div className="close" onClick={hide} />

		<div className="side left">
		    <h1>
			Don’t let<br />the fun<br />stop here!<br />
			<span>No spam,<br />only the good<br />stuff.</span>
		    </h1>
		</div>
		<div className="side right">
		    <div className="formWrapper">
			{formContent}
		    </div>

		    <div className="link">
			<a target="_blank" href="https://anytype.io/website_privacy">Privacy Policy</a>
		    </div>
		</div>
	    </div>
	</div>
    );
});

export default Popup;